// scroll-to-section.js
// Generic smooth scroll to section by id or hash
import { NAV_OFFSET } from './constants';

/**
 * Scrolls smoothly to a section by id or hash.
 * @param {string} section - Section id (e.g. 'contact') or hash (e.g. '#contact')
 */
export function scrollToSection(section) {
  let id = section;
  if (section.startsWith('#')) {
    id = section.replace('#', '');
  }
  const el = document.getElementById(id);
  if (el) {
    const yOffset = -NAV_OFFSET;
    const y = el.getBoundingClientRect().top + window.scrollY + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
    return true;
  } else {
    // fallback: update hash if not found
    window.location.hash = '#' + id;
    return false;
  }
}
